import { render, staticRenderFns } from "./TncGuidanceTable.vue?vue&type=template&id=288725f4&scoped=true&"
import script from "./TncGuidanceTable.vue?vue&type=script&lang=js&"
export * from "./TncGuidanceTable.vue?vue&type=script&lang=js&"
import style0 from "./TncGuidanceTable.vue?vue&type=style&index=0&id=288725f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288725f4",
  null
  
)

export default component.exports